import styled from 'styled-components';

const Wrapper = styled.section`
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 1.75rem;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);
  margin-top: 1.5rem;

  h4 {
    font-size: 1rem;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
    text-align: center;
    margin-top: 0;
    margin-bottom: 1.5rem;
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0.4rem 0.875rem;
    font-size: 0.82rem;
    font-weight: 600;
    color: #475569;
    cursor: pointer;
    text-transform: capitalize;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
    margin-bottom: 1.25rem;

    &:hover {
      background: #eef2ff;
      color: #6366f1;
      border-color: #c7d2fe;
    }
  }
`;

export default Wrapper;
